import { useStateParams } from '../../../../hooks/use-state-params';
import { CONTRACTS_QUERY_SEARCH_PARAM_KEY } from './use-query-input-param-consts';

export function useQueryInputParams() {
  return useStateParams<string | undefined>(
    undefined,
    CONTRACTS_QUERY_SEARCH_PARAM_KEY,
    (query) => query,
    (query) => query ?? undefined,
  );
}
